import { Plant } from '@cemex-core/cmx-api';
import {
  OneClickOwnFreightPlantsActionTypes,
  OneClickOwnFreightPlantsActions,
} from '@ordersnproducts/modules/one-click-order/actions/one-click-ownFreight-plants.actions';

export interface OneClickOwnFreightPlantsState {
  loading: boolean;
  ownFreightPlantsAvailable: Plant[];
  selected: Plant;
}

export const initialState: OneClickOwnFreightPlantsState = {
  loading: false,
  ownFreightPlantsAvailable: [],
  selected: null,
};

export function reducer(state = initialState, action: OneClickOwnFreightPlantsActions): OneClickOwnFreightPlantsState {
  switch (action.type) {
    case OneClickOwnFreightPlantsActionTypes.LOAD_OWNFREIGHT_PLANTS: {
      return {
        ...state,
        loading: true,
      } as OneClickOwnFreightPlantsState;
    }
    case OneClickOwnFreightPlantsActionTypes.LOAD_OWNFREIGHT_PLANTS_COMPLETE: {
      return {
        ...state,
        loading: false,
        ownFreightPlantsAvailable: action.payload,
      } as OneClickOwnFreightPlantsState;
    }
    case OneClickOwnFreightPlantsActionTypes.SELECT_OWNFREIGHT_PLANT: {
      return {
        ...state,
        selected: action.payload,
      } as OneClickOwnFreightPlantsState;
    }
    case OneClickOwnFreightPlantsActionTypes.RESET: {
      return {
        ...initialState,
      };
    }
    default: {
      return state;
    }
  }
}
